import { http } from '../common/utils';

export const fetchBlob = async ({ url }) => {
  const response = await http.get(url, { responseType: 'blob' });

  return response;
};
